import { Outlet, useLoaderData } from "react-router-dom";
import instance from "../../../axios/instance";
import { getToken } from "../../../utils/token";
import { NoAccessInfo } from "../../../components/NoAccessInfo";

export const cmsLoader = async () => {
  const token = getToken();
  const res = await instance.get("/doctor/billing/plan/active", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return { plan: res.data };
};

export default function CMSLayout() {
  const { plan } = useLoaderData();
  const hasCMSAccess = plan?.name?.toLowerCase() === "supreme";

  return hasCMSAccess ? (
    <Outlet />
  ) : (
    <div className="bg-[#fafafa] max-w-[100%] w-full px-7 py-5">
      <NoAccessInfo
        msg={`Your current plan (${plan.name}) does not include the CMS feature`}
      />
    </div>
  );
}
